import Logo from "../../assets/logo_header.svg";
import {Link} from "react-router-dom";
import './TopMenu.css';

export const TopMenu = () =>  (
    <nav className="top-menu default-menu">
        <div className="logo-wrapper">
            <img src={Logo}/>
        </div>
        <div className="expand"></div>
        <div className="menu-items">
            <Link to="/" className="menu-item">Home</Link>
            <Link to="/company" className="menu-item">Company</Link>
            <Link to="/mission" className="menu-item">Mission</Link>
            <Link to="/services" className="menu-item">Services</Link>
            <a className="menu-item" href="#">Projects</a>
            <Link to="/contact-us" className="menu-item menu-item-accent">Get a Quote</Link>
        </div>
    </nav>
);